import axios from 'axios';
import { PERFORMANCE_DASHBOARD_DETAILS_REQUEST,
        PERFORMANCE_DASHBOARD_DETAILS_SUCCESS,
        PERFORMANCE_DASHBOARD_DETAILS_ERROR,

        SET_GPU_RAM_MEMORY_USAGE_REQUEST,
        SET_GPU_RAM_MEMORY_USAGE_SUCCESS,
        SET_GPU_RAM_MEMORY_USAGE_ERROR,
        

        SET_GPU_AVAILABLE_RAM_MEMORY_REQUEST,
        SET_GPU_AVAILABLE_RAM_MEMORY_SUCCESS,
        SET_GPU_AVAILABLE_RAM_MEMORY_ERROR,
    

        SET_CPU_UTILIZATION_REQUEST,
        SET_CPU_UTILIZATION_SUCCESS,
        SET_CPU_UTILIZATION_ERROR,
        

        SET_CPU_AVAILABLE_RAM_MEMORY_REQUEST,
        SET_CPU_AVAILABLE_RAM_MEMORY_SUCCESS,
        SET_CPU_AVAILABLE_RAM_MEMORY_ERROR,
        

        SET_CPU_RAM_MEMORY_USAGE_REQUEST,
        SET_CPU_RAM_MEMORY_USAGE_SUCCESS,
        SET_CPU_RAM_MEMORY_USAGE_ERROR
        } from './../../../constants/closeLoop/performanceDashboard/performanceDashboardConstants';

const URL = '/close_loop/performance_report/system_performance/';

export const fetchPerformanceDetails = (payload) => (dispatch) => {
    try {
        dispatch({type: PERFORMANCE_DASHBOARD_DETAILS_REQUEST})
        axios.post(URL, payload).then((response) => {
            if(response && response.status === 200) {
                console.log(response);
                console.log('200 Status Code')
                dispatch({type: PERFORMANCE_DASHBOARD_DETAILS_SUCCESS, payload: response.data['gpu_performance']})
            } else {
                console.log('Entered Else Clause');
                console.log(response);
                dispatch({type: PERFORMANCE_DASHBOARD_DETAILS_ERROR, payload: response.data.message})
            }
        }).catch((error) => {
            console.log('Error Occurred', error);
            dispatch({type: PERFORMANCE_DASHBOARD_DETAILS_ERROR, payload: error.response.data.message});
        })
    } catch(error) {
        console.log('Error', error);
        dispatch({type: PERFORMANCE_DASHBOARD_DETAILS_ERROR, payload: error.message})
    }
}


export const updateGPURAMMemoryUsage = (payload) => (dispatch) => {
    try {
        dispatch({type: SET_GPU_RAM_MEMORY_USAGE_REQUEST})
        axios.post(URL, payload).then((response) => {
            if(response && response.status === 200) {
                dispatch({type: SET_GPU_RAM_MEMORY_USAGE_SUCCESS, payload: response.data['gpu_performance']})
            } else {
                dispatch({type: SET_GPU_RAM_MEMORY_USAGE_ERROR, payload: response.data.message});
            }
        }).catch((error) => {
            console.log('Error Occurred', error);
            dispatch({type: SET_GPU_RAM_MEMORY_USAGE_ERROR, payload: error.response.data.message});
        })
    } catch(error) {
        console.log(error);
        dispatch({type: SET_GPU_RAM_MEMORY_USAGE_ERROR, payload: error.message})
    }
}


export const updateGPUAvailableRAMMemory = (payload) => (dispatch) => {
    try {
        dispatch({type: SET_GPU_AVAILABLE_RAM_MEMORY_REQUEST})
        axios.post(URL, payload).then((response) => {
            if(response && response.status === 200) {
                dispatch({type: SET_GPU_AVAILABLE_RAM_MEMORY_SUCCESS, payload: response.data['gpu_performance']})
            } else {
                dispatch({type: SET_GPU_AVAILABLE_RAM_MEMORY_ERROR, payload: response.data.message});
            }
        }).catch((error) => {
            console.log('Error Occurred', error);
            dispatch({type: SET_GPU_AVAILABLE_RAM_MEMORY_ERROR, payload: error.response.data.message});
        })
    } catch(error) {
        console.log(error);
        dispatch({type: SET_GPU_AVAILABLE_RAM_MEMORY_ERROR, payload: error.message});
    }
}


export const updateCPUUtilization = (payload) => (dispatch) => {
    try {
        dispatch({type: SET_CPU_UTILIZATION_REQUEST})
        axios.post(URL, payload).then((response) => {
            if(response && response.status === 200) {
                dispatch({type: SET_CPU_UTILIZATION_SUCCESS, payload: response.data['gpu_performance']});
            } else {
                dispatch({type: SET_CPU_UTILIZATION_ERROR, payload: response.data.message});
            }
        }).catch((error) => {
            console.log('Error Occurred', error)
            dispatch({type: SET_CPU_UTILIZATION_ERROR, payload: error.response.data.message});
        })
    } catch(error) {
        console.log(error);
        dispatch({type: SET_CPU_UTILIZATION_ERROR, payload: error.message});
    }
}


export const updateCPUAvailableRAMMemory = (payload) => (dispatch) => {
    try {
        dispatch({type: SET_CPU_AVAILABLE_RAM_MEMORY_REQUEST})
        axios.post(URL, payload).then((response) => {
            if(response && response.status === 200) {
                dispatch({type: SET_CPU_AVAILABLE_RAM_MEMORY_SUCCESS, payload: response.data['gpu_performance']})
            } else {
                dispatch({type: SET_CPU_AVAILABLE_RAM_MEMORY_ERROR, payload: response.data.message});
            }
        }).catch((error) => {
            console.log('Error Occurred', error);
            dispatch({type: SET_CPU_AVAILABLE_RAM_MEMORY_ERROR, payload: error.response.data.message});
        })
    } catch(error) {
        console.log(error);
        dispatch({type: SET_CPU_AVAILABLE_RAM_MEMORY_ERROR, payload: error.message});
    }
}


export const updateCPURAMMemoryUsage = (payload) => (dispatch) => {
    try {
        dispatch({type: SET_CPU_RAM_MEMORY_USAGE_REQUEST})
        axios.post(URL, payload).then((response) => {
            console.log(payload);
            console.log(response);
            if(response && response.status === 200) {
                dispatch({type: SET_CPU_RAM_MEMORY_USAGE_SUCCESS, payload: response.data['gpu_performance']})
            } else {
                dispatch({type: SET_CPU_RAM_MEMORY_USAGE_ERROR, payload: response.data.message});
            }
        }).catch((error) => {
            console.log('Error Occurred', error);
            dispatch({type: SET_CPU_RAM_MEMORY_USAGE_ERROR, payload: error.response.data.message});
        })
    } catch(error) {
        console.log(error);
        dispatch({type: SET_CPU_RAM_MEMORY_USAGE_ERROR, payload: error.message});
    }
}